import styled from 'styled-components';

export const MSDContainerStyled = styled.div`
  .title_layout {
    margin-bottom: 19px;
  }
`;
